import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import ActionText from '../../../../../../../../../components/ActionText'

import { getPeriodKeyFromFileRowIdAndCustomDate } from '../../../../../../../../../pages/MediaOrderSummary/MediaOrderSummaryContent/RequestedFilesSection/helpers'

import { PERIOD_IS_SELECTED, SELECTED_PERIODS } from '../../../../fields'
import { darkGrey, greyOutline } from '../../../../../../../../../styles/const/colors'

const customColorSchema = {
  color: greyOutline,
  hoverColor: darkGrey,
  touchedColor: darkGrey
}

const SelectOrDeselectAllButton = ({ formik, productFilesRequests }) => {
  const { t } = useTranslation()
  const { values, setFieldValue } = formik

  const allSelectedPeriods = values[SELECTED_PERIODS]

  const selectAllProductsPeriodsHandler = useCallback(() => {
    const updatedSelectedPeriods = productFilesRequests.reduce((newSelectedPeriods, file) => {
      const periodKey = getPeriodKeyFromFileRowIdAndCustomDate({
        fileId: file.requested_file.id,
        bookedMediaId: file.requested_file.booked_media_id,
        customDate: file.requested_file?.custom_date && file.requested_file.date_start
      })
      const period = values[SELECTED_PERIODS][periodKey]

      newSelectedPeriods[periodKey] = {
        ...period,
        [PERIOD_IS_SELECTED]: true
      }

      return newSelectedPeriods
    }, allSelectedPeriods)

    setFieldValue(SELECTED_PERIODS, updatedSelectedPeriods)
  }, [productFilesRequests, allSelectedPeriods, setFieldValue, values])

  const deselectAllProductsPeriodsHandler = useCallback(() => {
    const updatedSelectedPeriods = productFilesRequests.reduce((newSelectedPeriods, file) => {
      const periodKey = getPeriodKeyFromFileRowIdAndCustomDate({
        fileId: file.requested_file.id,
        bookedMediaId: file.requested_file.booked_media_id,
        customDate: file.requested_file?.custom_date && file.requested_file.date_start
      })

      const period = values[SELECTED_PERIODS][periodKey]
      newSelectedPeriods[periodKey] = {
        ...period,
        [PERIOD_IS_SELECTED]: false
      }

      return newSelectedPeriods
    }, allSelectedPeriods)

    setFieldValue(SELECTED_PERIODS, updatedSelectedPeriods)
  }, [productFilesRequests, allSelectedPeriods, setFieldValue, values])

  const isAllSelected = productFilesRequests.every(({ requested_file }) => {
    const periodKey = getPeriodKeyFromFileRowIdAndCustomDate({
      fileId: requested_file.id,
      bookedMediaId: requested_file.booked_media_id,
      customDate: requested_file?.custom_date && requested_file.date_start
    })

    return allSelectedPeriods[periodKey]?.[PERIOD_IS_SELECTED]
  })

  return isAllSelected ? (
    <ActionText customColorSchema={customColorSchema} onClick={deselectAllProductsPeriodsHandler}>
      {t('Deselect All')}
    </ActionText>
  ) : (
    <ActionText customColorSchema={customColorSchema} onClick={selectAllProductsPeriodsHandler}>
      {t('Select All')}
    </ActionText>
  )
}

SelectOrDeselectAllButton.propTypes = {
  formik: PropTypes.object,
  productFilesRequests: PropTypes.arrayOf(
    PropTypes.shape({
      requested_file: PropTypes.object,
      uploaded_files: PropTypes.array,
      booked_media: PropTypes.object,
      id: PropTypes.string
    })
  ).isRequired
}

export default SelectOrDeselectAllButton
